import React from 'react';
import { BusinessCard } from '.';
import noImage from '../../../public/noimage.png';
const InfoBussiness = [
  {
    image:
      '/images/anh9.jpg',
    title: 'Trứng gia cầm tươi',
    desc: 'Trứng gia cầm tươi, đa dạng chủng loại, được tuyển chọn kỹ, sạch và an toàn cho mọi nhu cầu chế biến hằng ngày.',
  },
  {
    image:
      '/images/anh7.jpg',
    title: 'Trứng bóc vỏ sẵn',
    desc: 'Trứng đã gia nhiệt, bóc vỏ sẵn, đảm bảo an toàn vệ sinh thực phẩm, tiện lợi và giúp tiết kiệm tối đa thời gian sơ chế.',
  },
  {
    image:
      '/images/anh10.jpg',
    title: 'Gia công bóc vỏ số lượng lớn',
    desc: 'Chuyên gia công bóc vỏ trứng số lượng lớn cho bếp ăn công nghiệp, nhà hàng, giúp tiết kiệm thời gian và nhân công.',
  },
];

const BusinessAreas = () => {
  return (
    <div className="container py-8 md:py-16 flex flex-col gap-6 md:gap-8 items-center">
      <p className="uppercase text-gray2 text-[24px] md:text-[32px] font-bold">
        Lĩnh vực kinh doanh
      </p>
      <div className="grid grid-cols-1 md:grid-cols-3 w-full gap-4 md:gap-4">
        {InfoBussiness.map((item, index) => (
          <BusinessCard key={index} {...item} />
        ))}
      </div>
    </div>
  );
};

export default BusinessAreas;
